import NavLeft from "./NavLeft"
import NavSearchBar from "./NavSearchBar"
import NavRight from "./NavRight"

const NavBar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="d-flex justify-content-between align-items-center container-fluid">
        <div className="d-flex align-items-center">
          <NavLeft />
        </div>

        <div
          className="d-flex justify-content-center px-3"
          style={{ minWidth: "50%" }}
        >
          <NavSearchBar />
        </div>

        <div className="d-flex align-items-center justify-content-end">
          <NavRight />
        </div>
      </div>
    </nav>
  )
}

export default NavBar
